function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 2.105c-1.377 0-2.493 1.036-2.493 2.313 0 1.277 1.116 2.313 2.493 2.313 1.377 0 2.493-1.036 2.493-2.313 0-1.277-1.116-2.313-2.493-2.313zM4.316 4.418C4.316 2.53 5.966 1 8 1c2.034 0 3.684 1.53 3.684 3.418 0 1.888-1.65 3.418-3.684 3.418-2.035 0-3.684-1.53-3.684-3.418zm-1.088 9.477h9.544C12.48 11.69 10.454 9.985 8 9.985s-4.479 1.706-4.772 3.91zM2 14.447C2 11.373 4.686 8.88 8 8.88s6 2.493 6 5.567c0 .306-.267.553-.596.553H2.596c-.33 0-.596-.247-.596-.553z",
  fill: "#2D2D2D"
});
function SvgPersonausuaria(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Persona usuaria.svg";
export { SvgPersonausuaria as ReactComponent };